import React from 'react'

const Heading = ({innerText}) => {
  return (
    <div>
        <h1 className='p-[20px] text-left text-3xl font-bold text-sky-950 '>{innerText}</h1>

    </div>
  )
}

export default Heading